var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScientificLblIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#000000;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 223.227,
    y: 108.949,
    className: "st0",
    width: 39.718,
    height: 8.854
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.227,
    y: 173.104,
    className: "st0",
    width: 39.718,
    height: 8.846
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.227,
    y: 76.867,
    className: "st0",
    width: 23.035,
    height: 8.864
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.227,
    y: 141.021,
    className: "st0",
    width: 23.035,
    height: 8.846
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.227,
    y: 205.177,
    className: "st0",
    width: 23.035,
    height: 8.856
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M400.257,222.334c-11.465-15.166-25.186-28.396-40.776-39.277c-11.194-7.837-23.173-14.345-35.76-19.424 V58.326c6.865-6.115,11.198-15.015,11.198-24.914C334.92,14.988,319.945,0,301.526,0h-91.051c-18.42,0-33.403,14.988-33.403,33.412 c0,9.899,4.343,18.799,11.208,24.914v105.306c-12.586,5.079-24.566,11.587-35.76,19.424c-15.591,10.881-29.31,24.111-40.776,39.277 c-23.87,31.573-36.496,69.234-36.496,108.922c0,48.274,18.813,93.666,52.953,127.792C162.325,493.183,207.726,512,255.996,512 c48.28,0,93.68-18.817,127.806-52.952c34.139-34.126,52.952-79.518,52.952-127.792 C436.754,291.568,424.127,253.907,400.257,222.334z M255.996,489.8c-87.565,0-158.549-70.984-158.549-158.544 c0-71.761,47.654-132.345,113.028-151.912V44.606c-6.19,0-11.202-5.016-11.202-11.194c0-6.204,5.012-11.212,11.202-11.212h91.051 c6.181,0,11.203,5.008,11.203,11.212c0,6.177-5.022,11.194-11.203,11.194v134.737c65.373,19.568,113.028,80.152,113.028,151.912 C414.553,418.816,343.57,489.8,255.996,489.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScientificLblIcon);
export default __webpack_public_path__ + "static/media/scientific-lbl-icon.969caab8e6aee52a145179e31b72ea09.svg";
export { ForwardRef as ReactComponent };